
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import './labels-mixin.js';
import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import PendoIcon from './pendo-icon.js';
import 'vue';
import 'lodash/get';
import './pendo-loading-mixin.js';
import './pendo-loading-indicator.js';
import 'v-tooltip';
import './tooltip-mixin.js';
import PendoTooltip from './pendo-tooltip.js';
import './pendo-divider.js';
import 'lodash/isNumber';
import './table-auto-height-mixin.js';
import 'popper.js';
import 'uuid';
import 'vue-resize';
import 'lodash/clamp';
import './picker-popover-mixin.js';
import 'lodash/debounce';
import './emitter-mixin.js';
import 'lodash/isFunction';
import './multiselect-helper-mixin.js';
import './pendo-multiselect-props.js';
import './pendo-multiselect-core.js';
import './pendo-multiselect-input.js';
import './pendo-multiselect-option.js';
import 'compute-scroll-into-view';
import './pendo-multiselect-options.js';
import './pendo-multiselect-trigger.js';
import './pendo-multiselect-value.js';
import PendoMultiselect from './pendo-multiselect.js';
import cloneDeep from 'lodash/cloneDeep';
import '@shopify/draggable/lib/es5/sortable.js';
import PendoDraggable from './pendo-draggable.js';

var script = {
  name: 'PendoColumnReorder',
  components: {
    PendoIcon,
    PendoMultiselect
  },
  directives: {
    PendoDraggable,
    PendoTooltip
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    availableColumns: {
      type: Array,
      default: () => []
    },
    disableFirst: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    valueKey: {
      type: String,
      default: 'prop'
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    placeholder: {
      type: String,
      default: 'Select Column'
    },
    addButtonLabel: {
      type: String,
      default: 'Add Column'
    },
    allSelectedText: {
      type: String,
      default: 'All available columns selected.'
    }
  },

  data() {
    return {
      allColumnsSelected: false
    };
  },

  computed: {
    disableAddColumn() {
      if (this.$slots.multiselect || this.$scopedSlots.multiselect) {
        return false;
      }

      return this.disabled || this.allColumnsSelected || this.value.length === this.availableColumns.length;
    }

  },
  methods: {
    updateColumnIndex({
      newIndex,
      oldIndex
    }) {
      if (newIndex !== oldIndex) {
        const columns = this.value.slice(0);
        columns.splice(newIndex, 0, ...columns.splice(oldIndex, 1));
        this.handleColumnsChange(columns);
      }
    },

    handleColumnSelect(column, index) {
      const columns = cloneDeep(this.value);
      columns.splice(index, 1, column);
      this.handleColumnsChange(columns);
    },

    handleAllColumnsSelected(value) {
      this.allColumnsSelected = value;
    },

    handleColumnsChange(columns) {
      this.$emit('columns-change', columns);
    },

    addColumn() {
      if (this.disableAddColumn) {
        return;
      }

      const columns = [...this.value, {}];
      this.handleColumnsChange(columns);
    },

    removeColumn(column, index) {
      if (index === 0 && this.disableFirst) {
        return;
      }

      const columns = this.value.slice(0, index).concat(this.value.slice(index + 1));
      this.handleColumnsChange(columns);
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    directives: [{
      name: "pendo-draggable",
      rawName: "v-pendo-draggable",
      value: {
        events: {
          'sortable:stop': _vm.updateColumnIndex
        }
      },
      expression: "{\n        events: {\n            'sortable:stop': updateColumnIndex\n        }\n    }"
    }],
    staticClass: "pendo-column-chooser__columns"
  }, [_vm._l(_vm.value, function (column, index) {
    return _c('div', {
      key: column[_vm.valueKey],
      staticClass: "pendo-column-chooser__column",
      class: {
        'is-disabled': index === 0 && _vm.disableFirst || _vm.disabled || column.disabled
      },
      attrs: {
        "pendo-draggable-ignore": index === 0 && _vm.disableFirst || _vm.disabled || column.disabled,
        "pendo-draggable-item": ""
      }
    }, [_c('div', {
      staticClass: "pendo-column-chooser__handle",
      attrs: {
        "pendo-draggable-handle": ""
      }
    }, [_c('pendo-icon', {
      attrs: {
        "type": "more-vertical",
        "size": "22"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "pendo-column-chooser__column-options"
    }, [_vm._t("multiselect", [_c('pendo-multiselect', {
      attrs: {
        "value": _vm.value,
        "multiple": "",
        "full-width": "",
        "hide-selected-options": "",
        "all-selected-text": _vm.allSelectedText,
        "options": _vm.availableColumns,
        "placeholder": _vm.value[index][_vm.labelKey] || _vm.placeholder,
        "value-key": _vm.valueKey,
        "label-key": _vm.labelKey,
        "max-trigger-width": 286,
        "max-menu-width": 286,
        "show-selected-values": false,
        "disabled": _vm.disableFirst && index === 0 || _vm.disabled
      },
      on: {
        "all-selected-change": _vm.handleAllColumnsSelected,
        "select": function ($event) {
          return _vm.handleColumnSelect($event, index);
        }
      }
    })], null, {
      model: _vm.value,
      index: index,
      handleColumnSelect: _vm.handleColumnSelect,
      availableColumns: _vm.availableColumns,
      disabled: _vm.disabled,
      placeholder: _vm.placeholder,
      valueKey: _vm.valueKey,
      labelKey: _vm.labelKey,
      disableFirst: _vm.disableFirst
    })], 2), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.value.length > 1 || _vm.disableFirst,
        expression: "value.length > 1 || disableFirst"
      }],
      staticClass: "pendo-column-chooser__remove",
      on: {
        "click": function ($event) {
          return _vm.removeColumn(column, index);
        }
      }
    }, [_c('pendo-icon', {
      attrs: {
        "type": "x-circle",
        "size": "16"
      }
    })], 1)]);
  }), _vm._v(" "), _vm._t("add-button", [_c('div', {
    directives: [{
      name: "pendo-tooltip",
      rawName: "v-pendo-tooltip",
      value: {
        content: _vm.allColumnsSelected ? _vm.allSelectedText : null,
        arrow: true
      },
      expression: "{ content: allColumnsSelected ? allSelectedText : null, arrow: true }"
    }],
    staticClass: "pendo-column-chooser__add-column",
    class: {
      'is-disabled': _vm.disableAddColumn
    },
    on: {
      "click": _vm.addColumn
    }
  }, [_c('pendo-icon', {
    attrs: {
      "type": "plus",
      "size": "16"
    }
  }), _vm._v("\n            " + _vm._s(_vm.addButtonLabel) + "\n        ")], 1)], null, {
    allColumnsSelected: _vm.allColumnsSelected,
    disableAddColumn: _vm.disableAddColumn,
    addColumn: _vm.addColumn
  })], 2);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-column-reorder.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoColumnReorder = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoColumnReorder;
